import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import App from './App';
import AllCommentsPage from './pages/AllCommentsPage';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/all-comments" element={<AllCommentsPage />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
